import { Fragment } from 'react';
import { trackAnalyticsCustomEvent } from '@ifixit/analytics';

// eslint-disable-next-line react/display-name -- FIXME: Component definition is missing display name
const withLanguageForm = (LanguagesContainer: any) => (props: any) => {
   const submit = (langid: string) => {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises -- FIXME: Promises must be awaited, end with...
      fetch(props.translationPreferencesUrl, {
         method: 'POST',
         body: JSON.stringify({ langid }),
      }).then(response => {
         // eslint-disable-next-line @typescript-eslint/no-floating-promises -- FIXME: Promises must be awaited, end with...
         response.json().then(json => {
            if (json.redirectUrl) {
               window.location.href = json.redirectUrl;
            } else {
               window.location.reload();
            }
         });
      });
   };

   const onClickLanguage = (clickedLangId: any) => {
      if (!App.canIBypassGAEventFiringOnMobile && App.lang != clickedLangId) {
         trackAnalyticsCustomEvent({
            eventCategory: 'Language',
            eventAction: `Language Switcher - ${App.lang} - ${clickedLangId}`,
         });
      }
      submit(clickedLangId);
   };

   return (
      <Fragment>
         <LanguagesContainer {...props} onClickLanguage={onClickLanguage} />
      </Fragment>
   );
};

export default withLanguageForm;
